import { render, staticRenderFns } from "./FindingComment.vue?vue&type=template&id=15e807e0"
import script from "./FindingComment.vue?vue&type=script&lang=js"
export * from "./FindingComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e807e0')) {
      api.createRecord('15e807e0', component.options)
    } else {
      api.reload('15e807e0', component.options)
    }
    module.hot.accept("./FindingComment.vue?vue&type=template&id=15e807e0", function () {
      api.rerender('15e807e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/FindingComment.vue"
export default component.exports